import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Réinitialise la position de scroll à chaque changement de route.
 * - Si l'URL contient un hash (#ancre), on laisse le navigateur / la page
 *   cible gérer le scroll vers l'ancre.
 * - Sinon, on remonte instantanément en haut (window + document).
 *
 * Doit être monté à l'intérieur de <BrowserRouter>.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // Désactive la restauration auto du navigateur pour éviter qu'il
    // ré-applique l'ancien Y après notre scrollTo.
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
